import createPermission from 'permissions/createPermission'

export const upload = createPermission('unit.config.upload')
export const download = createPermission('unit.config.download')
export const backup = createPermission('unit.config.backup')
export const makeBasic = createPermission('units.basicConfig.create')